import { call, put, select } from 'redux-saga/effects'
import { updateContractConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectEnergyAuthCommonData } from '@/containers/Login/AuthSelectors'
import {
  selectComparatorSearchInputs,
  selectConfig,
  selectProviderConfigCurrentContractActive,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { buildComparatorConsumption, buildComparatorPayload, comparatorSearchKey } from './comparatorPayloadGeneration'

export const engineComparatorActions = {
  ENGINE_COMPARATOR_SEARCH: 'ENGINE_COMPARATOR_SEARCH',
}

export function* fetchEngineComparatorOffers({ id }) {
  const { calculateMonthlyAmountUrl } = yield select(selectEnergyAuthCommonData)
  const { contactId } = yield select(selectConfig)
  const { providerWorkflow } = yield select(selectProviderConfigCurrentContractActive)
  const searchInputs = yield select(selectComparatorSearchInputs)

  yield put(
    updateContractConfigData({
      id,
      data: {
        comparatorLoading: true,
        comparatorError: null,
        comparatorOffers: [],
        comparatorParams: null,
        comparatorAppliedParameters: null,
      },
    }),
  )

  try {
    const consumption = buildComparatorConsumption(searchInputs)
    const payload = buildComparatorPayload({
      ...searchInputs,
      consumption,
      providerWorkflow,
      contractId: id,
      contactId,
    })

    yield put(
      updateContractConfigData({
        id,
        data: {
          comparatorParams: { ...consumption, energyType: searchInputs.energyType },
          comparatorSearchKey: comparatorSearchKey(payload),
        },
      }),
    )

    yield call(callApi, {
      endpoint: calculateMonthlyAmountUrl,
      showErrorSnackbar: false,
      method: 'POST',
      payload,
    })
  } catch (error) {
    yield put(
      updateContractConfigData({
        id,
        data: {
          comparatorLoading: false,
          comparatorError: error.responseData?.message || 'Engine Comparator Error',
        },
      }),
    )
  }
}
